export default __webpack_public_path__ + "static/media/xsx-icon.38bf83c9.svg";